import { useEffect, useState } from "react";
import { mailV2Api, type MailAttachmentDTO } from "../../../api/mail-v2";

/** Loads attachments belonging to the message open in the detail pane. */
export function useMessageAttachments(
  messageId: string | null | undefined,
  enabled: boolean,
) {
  const [items, setItems] = useState<MailAttachmentDTO[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled || !messageId) {
      setItems([]);
      setError(null);
      return;
    }
    let cancelled = false;
    setError(null);
    mailV2Api.listMessageAttachments(messageId)
      .then((rows) => {
        if (!cancelled) setItems(rows ?? []);
      })
      .catch((e: unknown) => {
        if (cancelled) return;
        setItems([]);
        setError(e instanceof Error ? e.message : String(e));
      });
    return () => {
      cancelled = true;
    };
  }, [enabled, messageId]);

  return { items, error };
}
